export const yacanConfig = {
  connection: {
    title: "Connexion YACAN",
    subtitle:
      "Connectez votre compte YACAN pour gérer l'accès de vos clients avec vos serrures.",
    connected: "Compte connecté",
    notConnected: "Non connecté",
    info:
      "Lorsque vous cliquez sur <b>Se connecter avec YACAN</b>, une fenêtre s'ouvre pour vous connecter et autoriser l'accès. La connexion est enregistrée pour l'ensemble de votre compte et utilisée sur tous vos établissements.",
    connect: "Se connecter avec YACAN",
    waiting: "En attente d'autorisation...",
    connectedTitle: "Compte YACAN connecté",
    authActive: "Autorisation active",
    reauthorize: "Réautoriser",
    reauthorizeTitle: "Autoriser à nouveau",
    disconnect: "Déconnecter",
  },
  locks: {
    title: "Serrures pour cet établissement",
    subtitle: "Sélectionnez les serrures YACAN qui s'appliquent à <b>cet établissement</b>.",
    selectedCount: "{count} sélectionnée(s)",
    noneFound: "Aucune serrure n'a été trouvée dans votre compte YACAN.",
    refresh: "Actualiser",
    placeholder: "Sélectionner des serrures…",
    summary: "{count} serrure(s) sélectionnée(s)",
    empty: "Aucune serrure sélectionnée",
    lockFallback: "Serrure {id}",
    save: "Enregistrer les serrures pour cet établissement",
    saving: "Enregistrement...",
  },
  assign: {
    title: "Attribution (PMS)",
    subtitle: "Attribuez chaque serrure à <b>Porte principale</b>, <b>Unité</b> ou <b>Portail</b>.",
    assignedCount: "{count} attribuée(s)",
    info:
      "Avec YACAN, <b>l'accès des clients est géré par YACAN</b> en fonction de la réservation : aucun code PIN n'est généré ici. Lorsqu'une réservation est confirmée, elle se synchronise automatiquement avec YACAN.",
    lockFallback: "Serrure {id}",
    assignmentLabel: "Attribution",
    typeNone: "Non attribuée",
    typeCommon: "Porte principale (partagée)",
    typeUnit: "Porte d'appartement",
    typeGate: "Portail / Garage",
    unitLabel: "Unité / Hébergement",
    unitPlaceholder: "Sélectionner une unité",
    unitFallback: "Unité {id}",
    save: "Enregistrer l'attribution",
    saving: "Enregistrement...",
  },
  msg: {
    connectStartError: "La connexion avec YACAN n'a pas pu être établie",
    popupBlocked: "Autorisez les fenêtres pop-up pour vous connecter avec YACAN.",
    connectError: "Erreur lors de la connexion avec YACAN",
    connectSuccess: "Compte YACAN connecté avec succès",
    connectFailed: "Impossible de se connecter avec YACAN",
    disconnectConfirm:
      "Déconnecter votre compte YACAN ? Les réservations ne seront plus synchronisées avec YACAN.",
    disconnectSuccess: "Compte YACAN déconnecté",
    disconnectError: "Impossible de déconnecter",
    locksLoadError: "Les serrures n'ont pas pu être chargées",
    locksLoadError2: "Erreur lors du chargement des serrures YACAN",
    selectAtLeastOne: "Sélectionnez au moins une serrure.",
    lockDefaultName: "Serrure YACAN",
    locksSaved: "Serrures enregistrées pour cet établissement",
    locksSaveError: "Les serrures n'ont pas pu être enregistrées",
    saveError: "Erreur lors de l'enregistrement",
    selectUnitForApartment: "Sélectionnez l'unité pour les serrures de type « Porte d'appartement ».",
    assignSaved: "Attribution enregistrée avec succès",
    assignSaveError: "L'attribution n'a pas pu être enregistrée",
    assignSaveError2: "Erreur lors de l'enregistrement de l'attribution",
  },
};
